// extracted by extract-css-chunks-webpack-plugin
module.exports = {"container":"page-title__container___HCliR","name":"page-title__name___1jhPr","title":"page-title__title___2GZof"};
    if(module.hot) {
      // 1748580937886
      var cssReload = require("../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  